import Emitter from "./eventEmitter";
const objects = {};
const waitingFetch = {};
let onStoreMethod = () => {};
export const emptyStore = () => {
  Object.keys(objects).forEach((modelName) => {
    delete objects[modelName];
  });
};
export const onStore = (newOnStoreMethod) => {
  // used to know when to record the ids
  onStoreMethod = newOnStoreMethod;
};
export const storedIds = () => {
  const ids = {};
  Object.keys(objects).forEach((model) => {
    ids[model] = Object.keys(objects[model]);
  });
  // console.log(objects, ids)
  return ids;
};
export const fetch = (modelName, id) => {
  if (objects[modelName] && objects[modelName][id])
    return new Promise((resolve) => resolve(objects[modelName][id]));
  if (!waitingFetch[modelName]) waitingFetch[modelName] = {};
  if (!waitingFetch[modelName][id]) waitingFetch[modelName][id] = [];
  return new Promise((resolve) => {
    waitingFetch[modelName][id].push(resolve);
  });
};
export const store = (modelName, model) => {
  if (!objects[modelName]) objects[modelName] = {};
  let id = null;
  if (model.data) {
    id = model.data()._id;
  } else {
    id = model._id;
  }
  if (id) {
    objects[modelName][id] = model;
    if (waitingFetch[modelName] && waitingFetch[modelName][id]) {
      while (waitingFetch[modelName][id].length) {
        const resolve = waitingFetch[modelName][id].shift();
        resolve(model);
      }
    }
  }
  // console.log('store')
  Emitter.emit(modelName);
  onStoreMethod();
};
window.inboxStore = objects;
export default objects;
